export const prepareStochastic = (data, value) => {
    return {
        stochastic_d: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: value.stochastic_d[i] !== undefined ? value.stochastic_d[i] : null,
        })),
        stochastic_k: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: value.stochastic_k[i] !== undefined ? value.stochastic_k[i] : null,
        })),

    };
};
